<template>
<div class="sidebar">
    <b-nav >
        <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
        <b-nav-item to="/fonts" exact exact-active-class="active">
            <b-icon icon="fonts" scale="1.2" />
            <label><t nav.fonts /></label>
        </b-nav-item>
        <b-nav-item to="/icons" exact exact-active-class="active">
            <b-icon icon="star-fill" scale="0.8" />
            <label><t nav.icons /></label>
        </b-nav-item>
        <b-nav-item to="/articles" exact exact-active-class="active">
            <b-icon icon="table" scale="0.8" />
            <label><t nav.articles /></label>
        </b-nav-item>
        <b-nav-item to="/compositions" exact exact-active-class="active">
            <b-icon icon="box-seam" scale="0.8" />
            <label><t nav.compositions /></label>
        </b-nav-item>
        <b-nav-item to="/users" exact exact-active-class="active">
            <b-icon icon="people" scale="0.8" />
            <label><t nav.users /></label>
        </b-nav-item>
        <b-nav-item to="/translations" exact exact-active-class="active">
            <b-icon icon="spellcheck" scale="0.8" />
            <label><t nav.translations /></label>
        </b-nav-item>
    </b-nav>
    <label class="vertical-label">
        <t administration />
        <span class="language" :class="babelMode ? 'babelMode' : '' ">
            {{language}}
        </span>
    </label>
    </div>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
    import { BIcon, BIconFonts, BNav, BNavItem, BIconBoundingBox, BIconStarFill, BIconPeople, BIconBoxSeam, BIconList, BIconTable, BIconSpellcheck } from 'bootstrap-vue';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            BIcon,
            BIconFonts,
            BNav,
            BNavItem,
            BIconBoundingBox,
            BIconStarFill,
            BIconPeople,
            BIconBoxSeam,
            BIconList,
            BIconTable,
            BIconSpellcheck
        },
        name: 'Nav',
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters(['language', 'babelMode'])
        },
        methods: {
        }
    }
</script>


<style lang="scss" scoped>
    /* The sidebar menu */
    .sidebar {
        height: 100%; /* 100% Full-height */
        width: 0; /* 0 width - change this with JavaScript */
        position: fixed; /* Stay in place */
        z-index: 1; /* Stay on top */
        top: 0;
        left: 0;
        background-color: #111; /* Black*/
        overflow-x: hidden; /* Disable horizontal scroll */
        padding-top: 1em;
        transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */

        a {
            text-decoration: none;
            font-size: 25px;
            color: #818181;
            display: block;
            white-space: nowrap;

            label {
                margin-left:1rem;
                transition: 0.5s;
            }
        }

        a:hover,
        a.active {
            color: #f1f1f1;
        }
    }

    .vertical-label {
        transition: 0.5s;
        color: #818181;
        transform: rotate(180deg);
        position: absolute;
        font-variant-caps: all-small-caps;
        font-size: 200%;
        writing-mode: vertical-lr;
        bottom: 1rem;
    }

    .language {
        margin: 1em;
        padding: 1em;
        background-color: #444;
        color: #eee;
    }

    .language.babelMode {
        background-color: orange;
        color: #222;
    }

    .closedNav.sidebar {
        .vertical-label {
            transition: 0.5s;
            color: #f1f1f1;
        }

        a label{
            transition: 0.5s;
            color: #111;
        }
    }
</style>
